import { OptionDto } from "@/dtos";
import { IdentifierType } from "@/helpers/types";


const types = [
    { value: IdentifierType.COST_CENTER, label: 'Centro de Costo' },
    { value: IdentifierType.TYPE_TASK, label: 'Tipo de Tarea' },
] as OptionDto[];

export const getIdentifierTypeOptions = (): OptionDto[] => {
    return types;
}

export const getIdentifierTypeOption = (value?: number): OptionDto => {
    return types.find((x) => x.value == value) ?? types[0];
}